import React, { useState } from "react";
import emailjs from "emailjs-com";
import "./styles/ContactUs.css";
import WebsiteFooter from "../components/WebsiteFooter";

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .send(
        "service_k184vcg", // Replace with your EmailJS service ID
        "template_r49qudn", // Replace with your EmailJS template ID
        formData,
        "uoW3xsvAq-wBFjV-p"
      )
      .then(
        (result) => {
          setSuccessMessage("Your message has been sent successfully!");
          setFormData({ name: "", email: "", message: "" });
          alert("Message Sent!");
        },
        (error) => {
          console.error(error.message);
          setErrorMessage("Oops! Something went wrong. Please try again.");
        }
      );
  };

  return (
    <>
      <div className="contact-us-container">
        <div className="contact-us-container2">
          <h1>Contact Us</h1>
          <div className="contact-details">
            <br />
            <h4>
              We'd love to hear from you! Whether you have a question, feedback, or just want to say hi, feel free to reach out to us.
            </h4>
            <br />
            <h5>Our Address:</h5>
            <p>Bean Seven, 148-B, Juhu Tara Road, Juhu, Mumbai, Maharashtra, India - 400049.</p>
            <h5>Phone:</h5>
            <p>+91 99200 45256</p>

            <h5>Email:</h5>
            <p>care@konkanroute.com</p>
          </div>

          <form className="contact-form" onSubmit={sendEmail}>
            <h5>Send Us a Message</h5>
            <div className="form-group">
              <label htmlFor="name">Your Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Your Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Your Message:</label>
              <textarea
                id="message"
                name="message"
                placeholder="Enter your message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <button type="submit" className="submit-button">Send Message</button>
          </form>
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default ContactUs;
